import React from "react";
import AppContent from "./AppContent";
import { AppStoreProvider } from "./store/AppStoreProvider";
import { TealiumHandler } from "./TealiumHandler";
import { AlertMessageProvider } from "./contexts";

export const App = () => {
  return (
    <AppStoreProvider>
      <TealiumHandler>
        <AlertMessageProvider>
          <AppContent />
        </AlertMessageProvider>
      </TealiumHandler>
    </AppStoreProvider>
  );
};

export default App;
